module.exports = __webpack_public_path__ + "static/scale-model-of-michael-perry-park-in-tucson-arizona-6586e79ffa008e0b0b086216cf92fac3.png";